import { injectable } from 'tsyringe';
import { BaseApi } from '../BaseApi';
import { StreamingQuotes } from '../types/WebSocket.type';
import { WebSocketOptions, WsHandler } from '../WsHandler';
import { IWebSocketApi } from './interfaces/IWebSocketApi';

@injectable()
export class WebSocketApi extends BaseApi implements IWebSocketApi {
    private async getWebSocketUrl(endpoint: string) {
        if (!this.config.websocketUrl) {
            throw new Error('WebSocket url is not provided');
        }

        return `${this.config.websocketUrl}/${endpoint}?auth=${escape(
            'SessionId ' + (await this.sdks.orbis.client.getToken()),
        )}`;
    }

    private async createWsHandler<T>(endpoint: string, options?: WebSocketOptions<T>): Promise<WsHandler<T>> {
        const webSocket = new WsHandler(await this.getWebSocketUrl(endpoint), {
            ...options,
            onReconnect: async (event) => {
                webSocket.updateUrl(await this.getWebSocketUrl(endpoint));
                options?.onReconnect?.(event);
            },
        });

        return webSocket;
    }

    quotes(options?: WebSocketOptions<StreamingQuotes>): Promise<WsHandler<StreamingQuotes>> {
        return this.createWsHandler('stream/json', options);
    }

    equities(options?: WebSocketOptions): Promise<WsHandler> {
        return this.createWsHandler('equities', options);
    }

    orders(options?: WebSocketOptions): Promise<WsHandler> {
        return this.createWsHandler('orders/feed', options);
    }
}
